import getConfiguredEventEndTime from './getConfiguredEventEndTime';
import getConfiguredEventEndTimeBasedOnPreviousInterval from './getConfiguredEventEndTimeBasedOnPreviousInterval';
import { isEqual, OwaDate } from 'owa-datetime';

/**
 * Update the event end time when the 'End events early'/'Shorten events duration' setting is on
 * Used when selection is changed in scheduling grid and scheduling assistant
 * @param previousStart
 * @param previousEnd
 * @param newStart
 * @param newEnd
 */
export default function getConfiguredEventEndTimeBasedOnPreviousEnd(
    previousStart: OwaDate,
    previousEnd: OwaDate,
    newStart: OwaDate,
    newEnd: OwaDate
): OwaDate {
    if (isEqual(previousEnd, newEnd)) {
        return getConfiguredEventEndTimeBasedOnPreviousInterval(
            previousStart,
            previousEnd,
            newStart,
            newEnd
        );
    }

    return getConfiguredEventEndTime(newStart, newEnd);
}
